export default __webpack_public_path__ + "static/media/ic_metamask_hover_16.aa3dce32.svg";